import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { includes, mergeRight } from "ramda";
import { getOptimizedPdfUrl } from "../creator-application/content/contentServices";

export const HIDE_VIEWER = "media-viewer/HIDE_VIEWER";
export const SHOW_VIEWER = "media-viewer/SHOW_VIEWER";

export const VIEWER_EPUB = "media-viewer/VIEWER_EPUB";
export const VIEWER_PDF = "media-viewer/VIEWER_PDF";
export const VIEWER_IMAGE = "media-viewer/VIEWER_IMAGE";
export const VIEWER_IMAGE_BOOK = "media-viewer/VIEWER_IMAGE_BOOK";
export const VIEWER_AUDIO = "media-viewer/VIEWER_AUDIO";
export const VIEWER_VIDEO = "media-viewer/VIEWER_VIDEO";

// export const getViewerTypeForMedia = media => {
//   const { mimeType, type } = media;

//   if (
//     mimeType === "application/biblioboard+compound_content" &&
//     type !== "ALBUM"
//   ) {
//     return null;
//   } else if (mimeType === "application/epub+zip") {
//     return VIEWER_EPUB;
//   } else if (mimeType === "audio/mpeg" || type === "ALBUM") {
//     return VIEWER_AUDIO;
//   } else if (mimeType === "video/mp4") {
//     return VIEWER_VIDEO;
//   } else if (type === "IMAGE") {
//     return VIEWER_IMAGE;
//   } else if (
//     includes(type, ["ARTICLE", "OTHER_DOCUMENT"]) &&
//     mimeType === "image/jpeg"
//   ) {
//     return VIEWER_IMAGE;
//   } else if (type === "BOOK") {
//     if (mimeType === "image/jpeg" && !media.pdfUrl) {
//       return VIEWER_IMAGE;
//     } else {
//       return VIEWER_PDF;
//     }
//   } else if (
//     type === "CHAPTER" ||
//     type === "OTHER_DOCUMENT" ||
//     type === "ARTICLE"
//   ) {
//     return VIEWER_PDF;
//   }
// };

export const getViewerTypeForMedia = media => {
  const { mimeType, type, optimizedPdfUrl } = media;

  if (
    mimeType === "application/biblioboard+compound_content" &&
    type !== "ALBUM"
  ) {
    return null;
  } else if (mimeType === "application/epub+zip") {
    return VIEWER_EPUB;
  } else if (mimeType === "audio/mpeg" || type === "ALBUM") {
    return VIEWER_AUDIO;
  } else if (mimeType === "video/mp4") {
    return VIEWER_VIDEO;
  } else if (type === "IMAGE") {
    return VIEWER_IMAGE;
  } else if (includes(type, ["ARTICLE", "BOOK", "CHAPTER", "OTHER_DOCUMENT"])) {
    if (Boolean(optimizedPdfUrl)) {
      return VIEWER_PDF;
    } else {
      return VIEWER_IMAGE_BOOK;
    }
  }
};

const initialState = {
  openViewer: null,
  media: null,
};

export const useHandleOpenViewerClick = () => {
  const dispatch = useDispatch();
  const [isViewerLoading, setIsViewerLoading] = useState(false);

  const handleOpenViewerClick = useCallback(
    async content => {
      setIsViewerLoading(true);
      const optimizedPdfUrl = await getOptimizedPdfUrl(content);
      dispatch({
        type: SHOW_VIEWER,
        media: mergeRight(content, { optimizedPdfUrl }),
      });
      setIsViewerLoading(false);
    },
    [dispatch],
  );

  return { handleOpenViewerClick, isViewerLoading };
};

export const mediaViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case HIDE_VIEWER:
      return {
        ...state,
        openViewer: null,
        media: null,
      };
    case SHOW_VIEWER:
      return {
        ...state,
        openViewer: getViewerTypeForMedia(action.media),
        media: action.media,
      };
    default:
      return state;
  }
};
